import { render, staticRenderFns } from "./weChatTip.vue?vue&type=template&id=491a03e2&scoped=true&"
import script from "./weChatTip.vue?vue&type=script&lang=js&"
export * from "./weChatTip.vue?vue&type=script&lang=js&"
import style0 from "./weChatTip.vue?vue&type=style&index=0&id=491a03e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a03e2",
  null
  
)

export default component.exports